export default __webpack_public_path__ + "static/media/liked.687812dc.svg";